import { Component, Input, Output, OnInit, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { GeneratedcvService } from 'src/app/pages/profile/generatedcv/services/generatedcv.service';
import { GeneratedCVModel } from 'src/app/pages/profile/generatedcv/models/generated-cv-model';
import { ImageService } from 'src/app/services/image/image.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-popup-cv',
  templateUrl: './popup-cv.component.html',
  styleUrls: ['./popup-cv.component.css']
})
export class PopupCvComponent implements OnInit, OnChanges, OnDestroy {
  @Input() isvisible: boolean = false;
  @Output() close = new EventEmitter<void>();
  @Output() cvSelected = new EventEmitter<any>();

  generatedCvs: GeneratedCVModel[] = [];
  loading: boolean = false;
  error = '';
  
  mainURL = 'assets/cvs/';
  imagePath = environment.apiUrl + this.mainURL;
  cvImageUrls: { [key: string]: string } = {};

  constructor(
    private generatedcvService: GeneratedcvService,
    private imageService: ImageService
  ) {}

  ngOnInit() {
    if (this.isvisible) {
      this.loadPaidCVs();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isvisible'] && changes['isvisible'].currentValue === true) {
      this.loadPaidCVs();
    }
  }

  loadPaidCVs() {
    this.loading = true;
    this.error = '';
    
    this.generatedcvService.getGeneratedCV().subscribe({
      next: (response: any) => {
        this.generatedCvs = response.filter((cv: any) => 
          cv.pdfPath || cv.wordPath
        );
        this.loading = false;
        this.loadAllImages();
      },
      error: (err) => {
        console.error('Error loading CVs:', err);
        this.error = 'Failed to load CVs. Please try again.';
        this.loading = false;
      }
    });
  }

  loadAllImages() {
    this.generatedCvs.forEach((cv) => {
      if (cv.imagePath) {
        const fullImageUrl = this.imagePath + cv.imagePath;

        this.imageService.getSecureImage(fullImageUrl).subscribe({
          next: (blobUrl) => {
            this.cvImageUrls[cv.imagePath] = blobUrl;
          },
          error: (err) => {
            console.error('Error loading image:', err);
            this.cvImageUrls[cv.imagePath] = 'assets/img/placeholder.png';
          },
        });
      }
    });
  }

  getImageUrl(imagePath: string): string {
    return this.cvImageUrls[imagePath] || 'assets/img/placeholder.png';
  }

  selectCV(cv: any) {
    this.cvSelected.emit(cv);
    this.closePopup();
  }

  closePopup() {
    this.close.emit();
  }

  disableRightClick(event: MouseEvent) {
    event.preventDefault();
  }

  ngOnDestroy() {
    Object.values(this.cvImageUrls).forEach((url) => {
      if (url.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }
    });
  }
}